import { importProvidersFrom } from '@angular/core';
import { BdFeatureStatusModule } from '@bindoc-projects/security-feature';
/// <reference types="@angular/localize" />

import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';
import { provideVirtualClinicData } from '@bindoc-projects/virtual-clinic-lib/data';
import { provideUserFileData } from '@bindoc-projects/user-lib/data';
import { provideAuthenticatedApp } from '@bindoc-projects/app-starter-lib/bootstrap';
import { ClinicReadService } from '@bindoc-projects/clinic-domain-lib';
import { ClinicUnavailableReadService } from '@bindoc-projects/clinic-lib/data';

import { environment } from './environments/environment';
import { BrowserUtils } from '@azure/msal-browser';
import { BdAppConfigResponse } from '@bindoc-projects/app-config-domain-lib';

import { ANALYTICS_P21_APP_CONFIG_REQUEST } from './app-config';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { loadAppConfig } from '@bindoc-projects/app-starter-lib/bootstrap';
import {
  PrimeNgMetaConfig,
  provideUiTheme,
  withPrimeUiLicense,
} from '@bindoc-projects/theme-lib/ui';

import { ShareableType } from '@bindoc-projects/resource-domain-lib';

// MSAL v5 uses a hidden iframe for silent token renewal. Do not bootstrap
// the full app inside it — MSAL handles the token exchange at the protocol level.
if (!BrowserUtils.isInIframe()) {
  loadAppConfig(ANALYTICS_P21_APP_CONFIG_REQUEST, environment).then(
    (appConfig: BdAppConfigResponse) => {
      bootstrapApplication(AppComponent, {
        providers: [
          provideUiTheme(withPrimeUiLicense(PrimeNgMetaConfig, appConfig)),
          ...provideAuthenticatedApp({
            securityProviders: [importProvidersFrom(BdFeatureStatusModule)],
            config: appConfig,
            configRequest: ANALYTICS_P21_APP_CONFIG_REQUEST,
            appRoutingModule: AppRoutingModule,
            permissionPrefetch: false,
            explicitZoneless: false,
          }),
          {
            provide: ClinicReadService,
            useExisting: ClinicUnavailableReadService,
          },
          ...provideVirtualClinicData({
            endpoint: ApiEndpointKey.AYS_VIRTUAL_CLINIC_RESOURCE_URL,
            resourceNames: [ShareableType.VIRTUAL_CLINIC],
            resolveAnalysis: false,
          }),
          ...provideUserFileData(),
        ],
      }).catch((err) => {
        console.error('Error', err);
      });
    },
  );
}
